import React from 'react';
import './ShilajitBanner.css';
import bannerImg from '../components/assets/images/Mental.png';

const ShilajitBanner = () => {
  return (
    <a href="/shilajit" className="shilajit-banner-link">
      <div className="shilajit-banner" style={{ backgroundImage: `url(${bannerImg})` }}>
      </div>
    </a>
  );
};

export default ShilajitBanner;
